import { getIdReduxUtil } from '../../../../redux/utils/get-id'
import getCurrentWorkoutSectionSelect from '../get-current'
import { createSelector } from 'reselect'

const getCurrentIdWorkoutSectionSelect = createSelector(getCurrentWorkoutSectionSelect,
  (workoutSection) => {
    return getIdReduxUtil(workoutSection)
  }
)

export default getCurrentIdWorkoutSectionSelect
